<script lang="ts">
    import { H1, Label } from "attractions";
    import Currency from "../../../Utils/Currency";

    export let purchases: any[];

    let counter = 0;
    let total = 0;

    purchases.forEach(purchase => {
        counter++;
        total += parseFloat(purchase.price);
    });
</script>

<section class="total">
    <Label small>Wartość produktów:</Label>
    <H1 style="margin: 0.2rem 0">{Currency.format(total)}</H1>
    <Label>Naliczona na podstawie {counter} zakupów.</Label>
</section>

<style lang="scss">
    .total {
        text-align: right;
        margin-bottom: 1rem;
    }
</style>